import React from 'react';
import {Table,Popover,Button, Input, InputNumber, Popconfirm, Form, message, Card} from 'antd';
import {getAllfileUploadConfig, initFileUploadPathConfigs, saveFileUploadPathConfig} from "../actions";
import './resourcePath_Config.css';

/**
 * 资源路径配置页面。
 */
const sourceCode2Name = {
    1: '稿件',
    3: '线索',
    4: '活动',
    5: '资源上传申请',
    6: '微信',
    7: '微博',
    8: '抖音',
    9:'通知公告'
}


const fileType2Name = {
    2: '图片',
    3: '视频',
    4: '其他',
    5: '音频'
}

const EditableContext = React.createContext();

/**
 * 可编辑的  表格
 */
class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber/>;
        }
        return <Input/>;
    };

    renderCell = ({getFieldDecorator}) => {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{margin: 0}}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: true,
                                    message: `请输入${title}！`,
                                },
                            ],
                            initialValue: record[dataIndex],
                        })(this.getInput())}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}


/**
 * 编辑  路径配置表格
 */
class ResourcePathConfig extends React.Component {


    constructor(props) {
        super(props);
        this.state = {editingKey: '', data: []};

        this.columns = [
            {
                title: '数据来源',
                dataIndex: 'name',
                width: '20%',
                editable: false,
                render: (text, row, index) => {
                    return sourceCode2Name[row.fileSource]
                }
            },
            {
                title: '文件类型',
                dataIndex: 'age',
                editable: false,
                width: '10%',
                render: (text, row, index) => {
                    return fileType2Name[row.fileType]
                }
            },
            {
                title: '资源存储路径',
                dataIndex: 'configPaths',
                editable: true,
                width: '50%',
            },
            {
                title: '操作',
                dataIndex: 'operation',
                width: '20%',
                render: (text, record) => {
                    const {editingKey} = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                        <span>
              <EditableContext.Consumer>
                {form => (
                    <a
                        onClick={() => this.save(form, record._id)}
                        style={{marginRight: 8}}
                    >
                        保存
                    </a>
                )}
              </EditableContext.Consumer>
              <Popconfirm title="确定要取消吗?" onConfirm={() => this.cancel(record._id)}>
                <a>取消</a>
              </Popconfirm>
            </span>
                    ) : (
                        <a disabled={editingKey !== ''} onClick={() => this.edit(record._id)}>
                            编辑
                        </a>
                    );
                },
            },
        ];
    }

    isEditing = record => record._id === this.state.editingKey;

    cancel = () => {
        this.setState({editingKey: ''});
    };

    save(form, key) {
        let newData = this.state.data;
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const index = newData.findIndex(item => key === item._id);
            if (index > -1) {

                const item = newData[index];

                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                this.setState({data: newData, editingKey: ''});

                //保存数据入库；
                let paramData = {...item, ...row,};
                saveFileUploadPathConfig(paramData, this.callsaveFileUploadPathConfig.bind(this));

            } else {
                newData.push(row);
                const item2 = newData[index];
                this.setState({data: newData, editingKey: ''});
                //保存数据入库；
                let paramData = {...item2, ...row,};
                saveFileUploadPathConfig(paramData, this.callsaveFileUploadPathConfig.bind(this));
            }
        });
    }

    callsaveFileUploadPathConfig(data) {
        if (data) {
            message.info("保存成功！");
        }
    }

    edit(key) {
        this.setState({editingKey: key});
    }

    componentWillMount() {
        initFileUploadPathConfigs({}, this.callinitFileUploadPathConfigs.bind(this));
    }

    callinitFileUploadPathConfigs(data) {
        if (data) {
            let param = {};
            getAllfileUploadConfig(param, this.callgetAllfileUploadConfig.bind(this))
        }
    }


    callgetAllfileUploadConfig(data) {
        if (data) {
            this.setState({
                data: data
            })
        }
    }

    render() {
        const {data} = this.state;
        const components = {
            body: {
                cell: EditableCell,
            },
        };

        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        const helpInfo=<div>
            <h3>路径配置使用说明：</h3>
            <h4>1，{'{yyyy/MM/dd}'} 表示文件夹层级结构，是 ****年 **月 **日。</h4>
            <h4> 2，所有的配置的路径，都在 全部文件/全部（视频，音频，图片，其他的目录下面）</h4>
            <h4>3，文件目录层级使用"/"分割开（例如"稿件/图片/yyyy/MM/dd"））</h4>
            <h4>4，{'{title}'}占位符会替换成标题名称</h4>
            <h4>5，{'{storyDeptName}'}占位符会替换成稿件的部门名称（目前只有稿件可以配置这个）</h4>
            <h4>6，{'{storySource}'}稿件是投稿端写的还是管理端写的(放到对应的投稿端目录和管理端目录中)（目前只有稿件可以配置这个）</h4>
            <h4>7，{'{groupPicFileName}'}占位符会替换成组图配置的名称（目前只有稿件可以配置这个）</h4>
            <h4>8，{'{yyyy/MM}'}表示文件夹层级结构，是 ****年 **月</h4>
            <h4>9，{'{yyyy年MM月dd日_title}'}表示文件夹层级结构，yyyy年MM月dd日_title（活动名称或者稿件标题）</h4>
        </div>
        return (
            <div className={"resource"}>
                <Popover content={helpInfo} title="资源路径配置说明">
                    <Button type="primary">使用说明</Button>
                </Popover>,
                <Card title="资源路径配置列表" bordered={false}>
                    <div style={{marginTop:'10px'}}>
                        <EditableContext.Provider value={this.props.form}>
                            <Table
                                components={components}
                                rowClassName={'editable-row'}
                                bordered
                                dataSource={data}
                                pagination={{onChange: this.cancel}}
                                columns={columns}
                            />
                        </EditableContext.Provider>
                    </div>
                </Card>
            </div>
        );
    }
};

export default ResourcePathConfig = Form.create()(ResourcePathConfig);
